import { useState, useEffect, useCallback, useRef } from 'react'
import { useDispatch } from 'react-redux';

const useFetch = (action, options, onFetch) => {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const isMountedRef = useRef(true);

  const fetchData = useCallback(() => {
    setLoading(true);
    setResponse(null);
    const timeoutId = setTimeout(() => {
      dispatch(action(options))
        .then(result => {
          if (!isMountedRef.current) return;
          if (result.success) {
            if (onFetch) onFetch(result.data);
            setResponse(result.data);
          } else {
            setError(result.error);
          }
        })
        .catch(err => {
          if (isMountedRef.current) setError(err.message);
        })
        .finally(() => {
          if (isMountedRef.current) setLoading(false);
        });
    }, 30);
    return () => clearTimeout(timeoutId);
  }, [action, dispatch, onFetch, options]);

  useEffect(() => {
    isMountedRef.current = true;
    const cleanup = fetchData();
    return () => {
      isMountedRef.current = false;
      if (typeof cleanup === 'function') cleanup();
    };
  }, [fetchData, options]);

  return { response, error, loading, refetch: fetchData };
};

export default useFetch
